export class BackendHttpError extends Error {
	public readonly httpStatus: number;
	public readonly requestUrl: string;

	constructor(status: number, url: string) {
		super(`Backend HTTP ${status}: non-JSON response`);
		this.name = 'BackendHttpError';
		this.httpStatus = status;
		this.requestUrl = url;
	}
}

/** Returns a BackendHttpError if the error is one, or if it is wrapped as the cause of another error. */
export function extractBackendHttpError(error: unknown): BackendHttpError | null {
	if (error instanceof BackendHttpError) {
		return error;
	}
	if (error instanceof Error && error.cause instanceof BackendHttpError) {
		return error.cause;
	}
	return null;
}
